import { useState, useEffect } from "react";
import { textStatusType } from "../shared/helpers";
const ASRVPQuickStatusView = (props) => {
    const [membershipTextBSColor, setMembershipTextBSColor] = useState();
    const [membershipText, setMembershipText] = useState();
    const [trainingTextBSColor, setTrainingTextBSColor] = useState();
    const [trainingText, setTrainingText] = useState();
    const [backgroundScreeningTextBSColor, setBackgroundTextBSColor] = useState();
    const [backgroundScreeningText, setBackgroundScreeningText] = useState();

    useEffect(() => {
        setMembershipTextBSColor(textStatusType(props?.model?.membershipCompliance?.statusColor));
        setMembershipText(getQuickStatusText(props?.model?.membershipCompliance?.statusColor));
        setTrainingTextBSColor(textStatusType(props?.model?.trainedActivity?.statusColor));
        setTrainingText(getQuickStatusText(props?.model?.trainedActivity?.statusColor));
        setBackgroundTextBSColor(textStatusType(props?.model?.backgroundScreening?.statusColor));
        setBackgroundScreeningText(getQuickStatusText(props?.model?.backgroundScreening?.statusColor));
    }, [props]);

    function getQuickStatusText(statusColor){
        switch(statusColor?.toLowerCase()){
            case 'blue':
                return 'Get Started';
            case 'red':
                return 'Requires Attention';
            case 'yellow':
                return 'Requires Attention';
            case 'green':
                return 'All Good';
            default:
                return '';
        };
    }


    return(
        <div className='card'>
                    <div className='card-header fw-bold'>Quick Status View:</div>
                    <div className="list-group list-group-flush">
                        <a href="#asrvp-membership-container" className='asrvp-membership-status list-group-item list-group-item-action'>
                            <span>
                                Membership:
                                <div className={'text-center fw-bold '+membershipTextBSColor}>{membershipText}</div>
                            </span>
                        </a>
                        <a href="#asrvp-training-container" className='asrvp-safesport-status list-group-item list-group-item-action'>
                            <span>
                                Training:
                                <div className={'text-center fw-bold '+trainingTextBSColor}>{trainingText}</div>
    
                            </span>
                        </a>
                        <a href="#asrvp-background-screening-container" className='asrvp-ncsi-status list-group-item list-group-item-action'>
                            <span>
                                Background Screening:
                                <div className={'text-center fw-bold '+backgroundScreeningTextBSColor}>{backgroundScreeningText}</div>
                            </span>
                        </a>
                    </div>
                </div>
    );
}

export default ASRVPQuickStatusView;